import type { Styles } from 'common/types';

export const styles: Styles = {
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    mt: 3,
  },
};
